import { render, staticRenderFns } from "./renewalorders.vue?vue&type=template&id=0905420a&scoped=true&"
import script from "./renewalorders.vue?vue&type=script&lang=js&"
export * from "./renewalorders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0905420a",
  null
  
)

export default component.exports